module.exports = __webpack_public_path__ + "img/img-03.21ec638b.png";